import React from "react";
import "./Contact.css";
import { Card, ListGroup, ListGroupItem } from "react-bootstrap";
import logo from "../assets/images/psimg.jpeg";
import resume from "../assets/resume/resume.pdf";

function Contact() {
  return (
    <div id="contact">
      <h1>Contact Me</h1>
      <div className="contactContainer">
        <div className="map">
          <iframe
            width="100%"
            height="100%"
            title="map"
            className="absolute inset-0"
            frameBorder={0}
            marginHeight={0}
            marginWidth={0}
            style={{ filter: "opacity(0.8)" }}
            src="https://www.google.com/maps/embed/v1/place?q=university+of+british+columbia&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
          />
        </div>
        <div className="contactInfo">
          <Card>
            <Card.Img variant="top" src={logo} className="logoImg" />
            <Card.Body>
              <Card.Title>Parmvir Shergill</Card.Title>
              <Card.Text>
                If you would like to collaborate on a project or simply get to know me, please shoot me a message!
              </Card.Text>
            </Card.Body>
            <ListGroup className="list-group-flush">
              <ListGroupItem id="groupItem">
                <a href="https://github.com/Parmvir-S" target="_blank" rel="noreferrer">
                  GitHub
                </a>
              </ListGroupItem>
              <ListGroupItem id="groupItem">
                <a
                  href="https://www.linkedin.com/in/parmvir-shergill-84208538/"
                  target="_blank"
                  rel="noreferrer"
                >
                  LinkedIn
                </a>
              </ListGroupItem>
              <ListGroupItem id="groupItem">
                <a
                  href="mailto: parmvir.shergill@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Email
                </a>
              </ListGroupItem>
            </ListGroup>
            <Card.Body>
              <Card.Link><a href={resume} download>Resume</a></Card.Link>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
}

export default Contact;
